import axios from "axios";
import { useMutation } from "react-query";

const API_PATH = "picking/";

export const useGetPickingProductsReportGroupByDocuments = () =>
  useMutation((queryString: string) =>
    axios
      .get(`${API_PATH}GetPickingProductsReportGroupByDocuments${queryString}`)
      .then((res) => res.data.data)
      .catch((reason) => Promise.reject(reason.response))
  );
